<div class="adr_counsel tab_content">


  <div class="contents">
    <div class="adr_counsel">
      <div class="form_input">
        <div class="top">
          <h2 class="title">ADR Counsel</h2>
        </div>

        <div class="pop_search">
          <div class="center">
            <div class="up">
              <div class="input">
                  <label for="">Search counsel type</label>
                  <select class="default_input" #name (change)="selectCounselType(name.value)" >     
                    <!-- <input type="text" #name (keyup)="searchCounselType(name.value)"/> --> 
                    <option>Select counsel type</option>
                    <option class='option' *ngFor="let option of counseltypes" [value]="option.id">
                      {{ option.CounselTypeName }}
                    </option>
                  </select>
              </div>
              <!-- <div class="input">
                <label for="">Search counsel type</label>
                <input type="text" class="default_input" #name (keyup)="searchCounselType(name.value)"/>
              </div> -->
            </div>
          </div>
          <!-- <div class="search_result" >
            <table class="table table-hover" >
              <tbody >
                <tr *ngFor="let option of filteredCounselType; index as i">
                  <div class="dropdown-content" *ngIf="hidelist && option">
                    <a (click)="selectCounselType(option.id)">{{option.CounselTypeName}}</a>
                  </div>
                </tr>
              </tbody>
            </table>
          </div> -->
          <div class="toggle_view">
            <mat-button-toggle-group
            name="fontStyle"
            aria-label="Font Style"
            color="accent"
            class="m-3"
            >
            <mat-button-toggle value="list" color="accent" (click)="onList()"
              ><mat-icon class="example-tab-icon"
                >list</mat-icon
              ></mat-button-toggle
            >
            <mat-button-toggle value="grid" (click)="onGrid()"
              ><mat-icon class="example-tab-icon"
                >view_module</mat-icon
              ></mat-button-toggle
            >
            </mat-button-toggle-group>
          </div>
        </div>





          
      </div>
<div  *ngIf="gridView">
<div class="entry_values" *ngFor="let suitCounsel of filteredSuitCounsel; index as i" >
        <div class="entry">
          <h1 class="section_name">{{suitCounsel.CounselName}}</h1>

          <p class="remark">
            <span class="label">Remark</span>
            <span class="main_remark">
              {{suitCounsel.Remarks}}
            </span>
          </p>
        </div>       
      </div>
</div>
      
    </div>
  </div>
  <div class="card" *ngIf="listView">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Counsel Name</th>
          <th scope="col">Remarks</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="let suitCounsel of filteredSuitCounsel; index as i">
          <th scope="row">{{i + 1}}</th>
          <td>{{suitCounsel.CounselName}}</td>
          <td>{{suitCounsel.Remarks}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>